/* Adaptadores entre o contrato do design system e os `setState` das telas.
 *
 * Os componentes do design repassam `aoMudar` **direto para o `onChange`** do
 * elemento nativo:
 *
 *     onChange: aoMudar
 *
 * Ou seja, `aoMudar` recebe o **evento**, não o valor. Passar um setter cru
 * (`aoMudar={definirEmail}`) grava o objeto de evento no estado, e o campo
 * passa a mostrar `[object Object]` — que foi exatamente o defeito relatado ao
 * tentar digitar o e-mail na tela de entrada.
 *
 * Extrair o valor no ponto de uso resolveria, mas espalharia
 * `(e) => definir(e.target.value)` por dezessete lugares — e a distinção entre
 * `.value` e `.checked` seria redescoberta em cada um. Aqui é uma vez só.
 */

/** Campo de texto, textarea, select: o valor está em `target.value`. */
export function aoDigitar(definir) {
  return (evento) => definir(evento?.target?.value ?? '');
}

/** Checkbox e alternador: o que importa é `target.checked`, não `value`. */
export function aoMarcar(definir) {
  return (evento) => definir(Boolean(evento?.target?.checked));
}
